"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTypes = void 0;
var AuthTypes;
(function (AuthTypes) {
    AuthTypes["Anonymous"] = "Anonymous";
    AuthTypes["Basic"] = "Basic";
    AuthTypes["X_API_KEY"] = "X-API-Key";
    AuthTypes["Token"] = "Token";
    AuthTypes["User"] = "User";
    AuthTypes["FirebaseUser"] = "FirebaseUser";
    AuthTypes["OAuth2"] = "OAuth2";
})(AuthTypes = exports.AuthTypes || (exports.AuthTypes = {}));
//# sourceMappingURL=definitions.js.map